"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentModel = void 0;
var Model_1 = __importDefault(require("../Model"));
var array_1 = require("../../helpers/array");
var date_1 = require("../../helpers/date");
var CommentModel = /** @class */ (function (_super) {
    __extends(CommentModel, _super);
    function CommentModel(comment, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = comment.id;
        _this.userId = comment.userId;
        _this.createdAt = comment.createdAt;
        _this.updatedAt = comment.updatedAt;
        _this.questionId = comment.questionId;
        _this.score = comment.score;
        _this.attemptCount = comment.attemptCount;
        _this.contentsByCommentId = comment.contentsByCommentId;
        _this.exerciseCommentAttachmentsByCommentId = comment.exerciseCommentAttachmentsByCommentId || [];
        return _this;
    }
    Object.defineProperty(CommentModel.prototype, "user", {
        get: function () {
            return this.getters.userById(this.userId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentModel.prototype, "timeSinceCreation", {
        get: function () {
            return date_1.timeSinceCreation(this.attemptCount !== null ? this.updatedAt : this.createdAt);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentModel.prototype, "contents", {
        get: function () {
            var _this = this;
            return this.contentsByCommentId
                .map(function (contentId) { return _this.getters.contentById(contentId); })
                .sort(array_1.positionAscending);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentModel.prototype, "exerciseCommentAttachments", {
        get: function () {
            var _this = this;
            return this.exerciseCommentAttachmentsByCommentId.map(function (attachmentId) {
                return _this.getters.exerciseCommentAttachmentsById(attachmentId);
            });
        },
        enumerable: false,
        configurable: true
    });
    return CommentModel;
}(Model_1.default));
exports.CommentModel = CommentModel;
